import { render, staticRenderFns } from "./ImgModal.vue?vue&type=template&id=1b7382e8&scoped=true&"
import script from "./ImgModal.vue?vue&type=script&lang=js&"
export * from "./ImgModal.vue?vue&type=script&lang=js&"
import style0 from "./ImgModal.vue?vue&type=style&index=0&id=1b7382e8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7382e8",
  null
  
)

export default component.exports